import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector, userSelector } from "store/auth";
import Header, { HeaderLogo, HeaderUserDropdown } from "views/components/Header";
import { default as RootAboutNavigationOffCanvas } from "views/off-canvas/RootAboutNavigation";
import { default as RootNavigationOffCanvas } from "views/off-canvas/RootNavigation";
import RootCareersNav from "views/sections/RootCareersNav";
import RootHomeNav from "views/sections/RootHomeNav";
import { isOpenedInIframe } from "utils/helpers";

const RootHeader = ({ type = "", allowHeaderContent, isHeaderSticky, isHeaderFixed, allowHeaderActions, isDemo }) => {
	const { t } = useTranslation();

	// redux global state
	const user = useSelector(userSelector);
	const isAuthenticated = useSelector(isAuthenticatedSelector);

	if (isOpenedInIframe()) return null;
	return (
		<Header type={type} isSticky={isHeaderSticky} isFixed={isHeaderFixed} isDemo={isDemo}>
			{allowHeaderContent && type && (
				<>
					{["auth", "notes"]?.includes(type) ? (
						(type === "auth" && isAuthenticated && !user?.tenant?.is_demo) || type === "notes" ? (
							<div className="row gx-0 align-items-stretch flex-nowrap">
								{type === "notes" && (
									<div className={`col-auto ${isDemo ? "mx-auto" : ""}`}>
										<HeaderLogo type={type} isDemo={isDemo} />
									</div>
								)}
								{isAuthenticated && !user?.tenant?.is_demo ? (
									<div className="col-auto d-print-none ms-auto">
										<HeaderUserDropdown />
									</div>
								) : (
									<></>
								)}
							</div>
						) : (
							<></>
						)
					) : (
						<div className="container">
							<div className="row flex-nowrap align-items-center">
								<div className="col-5 col-md-3 col-xl-2">
									<HeaderLogo type={type} />
								</div>
								{allowHeaderActions ? (
									<>
										{["home", "webinar"].includes(type) ? (
											<div className="col ms-auto">
												<div className="row flex-nowrap">
													<div className="col">
														<RootHomeNav />
													</div>
													<div className="col-auto d-lg-none">
														<button
															className="btn btn-link link-primary-400 p-2 border-0 text-decoration-none rounded-pill text-uppercase"
															type="button"
															data-bs-toggle="offcanvas"
															data-bs-target="#root-navigation-offcanvas"
															aria-controls="root-navigation-offcanvas"
															aria-label={t("actions.open_navigation_menu")}>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="1.722222rem"
																height="1.111111rem"
																viewBox="0 0 31.368 20"
																aria-hidden="true">
																<g transform="translate(-328.513 -30.089)">
																	<line
																		x1="31.368"
																		transform="translate(328.513 31.089)"
																		fill="none"
																		stroke="currentColor"
																		strokeWidth="2"></line>
																	<line
																		x1="31.368"
																		transform="translate(328.513 40.089)"
																		fill="none"
																		stroke="currentColor"
																		strokeWidth="2"></line>
																	<line
																		x1="31.368"
																		transform="translate(328.513 49.089)"
																		fill="none"
																		stroke="currentColor"
																		strokeWidth="2"></line>
																</g>
															</svg>
														</button>
														<RootNavigationOffCanvas />
														<RootAboutNavigationOffCanvas />
													</div>
												</div>
											</div>
										) : (
											<></>
										)}
										{type === "careers" ? (
											<div className="col-6 col-md-5 col-xl-4 ms-auto">
												<RootCareersNav />
											</div>
										) : (
											<></>
										)}
									</>
								) : (
									<></>
								)}
							</div>
						</div>
					)}
				</>
			)}
		</Header>
	);
};

export default memo(RootHeader);
